import { render, staticRenderFns } from "./index-old.vue?vue&type=template&id=4fcde45f&"
import script from "./index-old.vue?vue&type=script&lang=js&"
export * from "./index-old.vue?vue&type=script&lang=js&"
import style0 from "./index-old.vue?vue&type=style&index=0&id=4fcde45f&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fcde45f')) {
      api.createRecord('4fcde45f', component.options)
    } else {
      api.reload('4fcde45f', component.options)
    }
    module.hot.accept("./index-old.vue?vue&type=template&id=4fcde45f&", function () {
      api.rerender('4fcde45f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/page/login/index-old.vue"
export default component.exports